module.exports = __webpack_public_path__ + "static/logoWithText-0260d8dd2de928b6480da8a8e5a4e7c8.svg";